import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PredefineArrayListService {

  constructor() { }


profileList=[
  { label: "Student's First Name", fieldNo: 1 },
  { label: "Student's Last Name", fieldNo: 2 },
  { label: 'Email', fieldNo: 4 },
  { label: 'Phone Number', fieldNo: 5 },
  { label: 'Age', fieldNo: 10 },
  { label: 'Marital Status', fieldNo: 11 },
  { label: 'Gender', fieldNo: 3 },
  { label: 'City', fieldNo: 13 },
  { label: 'US Citizen', fieldNo: 41 },
  { label: 'State of Residence', fieldNo:6 },
  { label: 'EFC', fieldNo: 40 },
  { label: 'GPA Scale', fieldNo: 266 },
  { label: 'GPA', fieldNo: 31 },
  { label: 'GPA', fieldNo: 274 },   //271 to 274 for 5 GPA
  { label: 'GPA', fieldNo: 276 },
  { label: 'GPA', fieldNo: 275 },
  { label: 'ACT', fieldNo: 32 },
  { label: 'Desired Field of Study', fieldNo: 35 },
  //
]

collegeSortByListWithoutLocation = [
  { label: 'By Rank', value: 'By_Rank' },
  { label: 'By Cost (Low to High)', value: 'By_Cost' },
  { label: 'Alphabetically (A-Z)', value: 'By_Alphabet_A_Z' },
  { label: 'Alphabetically (Z-A)', value: 'By_Alphabet_Z_A' },
   
];
  collegeSortByList = [
    { label: 'By Rank', value: 'By_Rank' },
    { label: 'By Cost (Low to High)', value: 'By_Cost' },
    { label: 'By Distance', value: 'By_Location' },
    { label: 'Alphabetically (A-Z)', value: 'By_Alphabet_A_Z' },
    { label: 'Alphabetically (Z-A)', value: 'By_Alphabet_Z_A' },
     
  ];

  cartViewCollegeSortByList = [
    { label: 'By Rank', value: 'By_Rank' },
    { label: 'By Cost (Low to High)', value: 'By_Cost' },
    { label: 'By Grant (High to Low)', value: 'By_Grant' },
    { label: 'Alphabetically (A-Z)', value: 'By_Alphabet_A_Z' },
    { label: 'Alphabetically (Z-A)', value: 'By_Alphabet_Z_A' },
    
     
  ];

  residenceFilterArray = [
    { label: 'In State, At Home', value: 'IN_STATE_OFF_CAMPUS_FAMILY' },
    { label: 'In State, On Campus', value: 'IN_STATE_ON_CAMPUS' },
    { label: 'Out State, On Campus', value: 'OUT_STATE_ON_CAMPUS' },
  ];
  enrollmentTypeList=[

    {
      label: '2-year',
      value: 'TWO_YEAR_PROGRAM',
    }, {
      label: '4-year',
      value: 'FOUR_YEAR_PROGRAM',
    }
  ]

  ddlAcceptanceRate = [
    
    {
      id: 'LOW',
      label: 'Elite (Acceptance Rate < 10%)'
    },
    {
      id: 'MEDIUM',
      label: 'Attainable (Acceptance Rate 10% to 35%)'
    },
    {
      id: 'HIGH',
      label: 'Accessible (Acceptance Rate > 35%)'
    }
  ];

  ddlPublicPrivateList = [
    {
      id: 'PUBLIC',
      label: 'Public',
      value: 'PUBLIC',
    },
    {
      id: 'PRIVATE_NON_PROFIT',
      label: 'Private, non-profit',
      value: 'PRIVATE_NON_PROFIT',
    },
    {
      id: 'PRIVATE_FOR_PROFIT',
      label: 'Private, for-profit',
      value: 'PRIVATE_FOR_PROFIT',
    }
  ];

  residencedropdownOptions = [
    {
      label: 'On Campus', value: 'IN_STATE_ON_CAMPUS', InOutState: 'true'
    },

    {
      label: 'Off Campus with Family',
      value: 'IN_STATE_OFF_CAMPUS_FAMILY',
      InOutState: 'true',
    },
    {
      label: 'Off Campus',
      value: 'IN_STATE_OFF_CAMPUS_NOT_FAMILY',
      InOutState: 'true',
    },
    { label: 'On Campus', value: 'OUT_STATE_ON_CAMPUS', InOutState: 'false' },
    {
      label: 'Off Campus with Family',
      value: 'OUT_STATE_OFF_CAMPUS_FAMILY',
      InOutState: 'false',
    },
    {
      label: 'Off Campus',
      value: 'OUT_STATE_OFF_CAMPUS_NOT_FAMILY',
      InOutState: 'false',
    },
  ];


  studentProfileStateCodeInstate = [
    {
      label: 'On Campus', value: 'IN_STATE_ON_CAMPUS', InOutState: 'true'
    },

    {
      label: 'Off Campus with Family',
      value: 'IN_STATE_OFF_CAMPUS_FAMILY',
      InOutState: 'true',
    },
    {
      label: 'Off Campus',
      value: 'IN_STATE_OFF_CAMPUS_NOT_FAMILY',
      InOutState: 'true',
    }
  ];

  residenceOptions = [
    { label: 'On Campus', value: 'ON_CAMPUS' },
    { label: 'Off Campus', value: 'OFF_CAMPUS_NOT_FAMILY' },
    { label: 'Off Campus with Family', value: 'OFF_CAMPUS_FAMILY' },
  ];


  // residenceFilterArray = [
  //   { label: 'In State, At Home', value: 'IN_STATE_OFF_CAMPUS_FAMILY' },
  //   { label: 'In State, On Campus', value: 'IN_STATE_ON_CAMPUS' },
  //   { label: 'Out State, On Campus', value: 'OUT_STATE_ON_CAMPUS' },
  // ];

  housingNotAvailableOption = [
    { label: 'Off Campus', value: 'OFF_CAMPUS_NOT_FAMILY' },
    { label: 'Off Campus with Family', value: 'OFF_CAMPUS_FAMILY' },
  ];

  housingAvailableOption = [
    { label: 'On Campus', value: 'ON_CAMPUS' },
    { label: 'Off Campus', value: 'OFF_CAMPUS_NOT_FAMILY' },
    { label: 'Off Campus with Family', value: 'OFF_CAMPUS_FAMILY' },
  ];

  selectedDefaultResidenceOptions = [
    'OFF_CAMPUS_NOT_FAMILY',
    'OFF_CAMPUS_NOT_FAMILY',
    'OFF_CAMPUS_NOT_FAMILY',
    'ON_CAMPUS',
  ];

  residenceOptionsCompare = [
    {
      domicileAndResidency: 'IN_STATE_ON_CAMPUS',
      label: 'On Campus',
      value: 'ON_CAMPUS',
      InOutState: 'true',
      src: 'https://cdn.virtueanalytics.com/cache/on-camp-top5.png',
    },
    {
      domicileAndResidency: 'IN_STATE_OFF_CAMPUS_FAMILY',
      label: 'Off Campus with Family',
      value: 'OFF_CAMPUS_FAMILY',
      InOutState: 'true',
      src: 'https://cdn.virtueanalytics.com/cache/on-camp-family-top5.png',
    },
    {
      domicileAndResidency: 'IN_STATE_OFF_CAMPUS_NOT_FAMILY',
      label: 'Off Campus',
      value: 'OFF_CAMPUS_NOT_FAMILY',
      InOutState: 'true',
      src: 'https://cdn.virtueanalytics.com/cache/off-camps.png',
    },
    {
      domicileAndResidency: 'OUT_STATE_ON_CAMPUS',
      label: 'On Campus',
      value: 'ON_CAMPUS',
      InOutState: 'false',
      src: 'https://cdn.virtueanalytics.com/cache/on-camp-family-top5.png',
    },
    {
      domicileAndResidency: 'OUT_STATE_OFF_CAMPUS_FAMILY',
      label: 'Off Campus with Family',
      value: 'OFF_CAMPUS_FAMILY',
      InOutState: 'false',
      src: 'https://cdn.virtueanalytics.com/cache/on-camp-family-top5.png',
    },
    {
      domicileAndResidency: 'OUT_STATE_OFF_CAMPUS_NOT_FAMILY',
      label: 'Off Campus',
      value: 'OFF_CAMPUS_NOT_FAMILY',
      InOutState: 'false',
      src: 'https://cdn.virtueanalytics.com/cache/off-camps.png',
    },
  ];

  housingNotAvailableOptionCompare = [
    {
      label: 'Off Campus',
      value: 'OFF_CAMPUS_NOT_FAMILY',
      src: 'https://cdn.virtueanalytics.com/cache/off-camps.png',
    },
    {
      label: 'Off Campus with Family',
      value: 'OFF_CAMPUS_FAMILY',
      src: 'https://cdn.virtueanalytics.com/cache/on-camp-family-top5.png',
    },
  ];

  housingAvailableOptionCompare = [
    {
      label: 'On Campus',
      value: 'ON_CAMPUS',
      src: 'https://cdn.virtueanalytics.com/cache/on-camp-top5.png',
    },
    {
      label: 'Off Campus',
      value: 'OFF_CAMPUS_NOT_FAMILY',
      src: 'https://cdn.virtueanalytics.com/cache/off-camps.png',
    },
    {
      label: 'Off Campus with Family',
      value: 'OFF_CAMPUS_FAMILY',
      src: 'https://cdn.virtueanalytics.com/cache/on-camp-family-top5.png',
    },
  ];


  yearWiseCollegeROIDataObj = {

    '2022': {
      'admissionsRate': 0,
      'graduationRate': 0,
      'npvAfterNYears': 0,
      'control': 0,
      'percentageEarningMoreThanHighSchoolGraduates': 0,
      'earningsPriceReturn': 0,
      'earningsDebtReturn': 0,
    },
    'year': {
      'admissionsRate': 0,
      'graduationRate': 0,
      'npvAfterNYears': 0,
      'control': 0,
      'percentageEarningMoreThanHighSchoolGraduates': 0,
      'earningsPriceReturn': 0,
      'earningsDebtReturn': 0,
    }
  }

  //Result Component 

  yearWiseCollegeROIData = [
    {
      fieldno: 777777,
      value: 'admissionsRate',
      label: 'Acceptance Rate',
      tooltip: '',
    },
    {
      fieldno: 888888,
      value: 'graduationRate',
      label: 'Graduation Rate',
      tooltip:
        'The rate at which full-time, first-time students complete their credentials within 150 percent of the expected time (e.g., the percentage of students who earn a bachelor’s degree within six years).',
    },
    {
      fieldno: 66,
      value: 'percentageEarningMoreThanHighSchoolGraduates',
      label: 'Students Earning more than High School Graduates',
      tooltip:
        'The share of students at an institution whose earnings 10 years after enrollment are higher than those of people with a high school diploma as their highest level of education.',
    },
    {
      fieldno: 1,
      value: 'npvAfterNYears',
      label: 'Net Present Value (after 10 years)',
      tooltip:
        'The net present value is how much a sum of money in the future is valued today. This metric includes costs, future earnings, and the length of time it would take to invest and earn a certain amount of money over a fixed horizon.',
    },
    // {
    //   fieldno: 2,
    //   value: 'npvAfterNYears',
    //   // label: 'Net Present Value (after 40 years)',
    //   label: 'Estimated Annual Earnings after Graduation',
    //   tooltip:'Estimated Annual Earnings after Graduation.',
    //   // tooltip:'The net present value is how much a sum of money in the future is valued today. This metric includes costs, future earnings, and the length of time it would take to invest and earn a certain amount of money over a fixed horizon.',
    // },
    // { value: 'netPrice', label: 'Net Price' },
    // {
    //   fieldno: 3,
    //   value: 'control',
    //   label: 'Type of Institution',
    //   tooltip:
    //     'Type designates whether an institution is a public, private nonprofit, or private for-profit institution.',
    // },


    // {
    //   fieldno: 4,
    //   value: 'earningsPriceReturn',
    //   label: 'Earnings-Price Return',
    //   tooltip:
    //     'A ratio that expresses how much earnings 10 years after enrollment are above or below the net price (in percent)—sometimes used to measure return. This measure is included for comparison to show that it does not fully account for return that has a time horizon.',
    // },
    // {
    //   fieldno: 5,
    //   value: 'earningsDebtReturn',
    //   label: 'Earnings-Debt Return',
    //   tooltip:
    //     'A ratio that expresses how much earnings 10 years after enrollment is above or below the median total debt (in percent)—sometimes used to measure return. This measure is included for comparison to show that it does not fully account for return that has a time horizon.',
    // },
  ];

  yearWiseCollegeGraguateRate = [
    {
      value: 'admissionsRate',
      label: 'Acceptance Rate',
      tooltip: '',
    },
    {
      value: 'graduationRate',
      label: 'Graduation Rate',
      tooltip:
        'The rate at which full-time, first-time students complete their credentials within 150 percent of the expected time (e.g., the percentage of students who earn a bachelor’s degree within six years).',
    },
  ];

  analysisDataKeys = [
    { value: 'graduationRate', label: 'Graduation Rate' },
    { value: 'npvAfter10Years', label: 'Net Present Value (NPV)' },
  ];

  feesBreakDownKeysLabel = [
    {
      value: 'tuitionAndFee',
      label: 'Tuition & Fee',
      fieldNo: '49',
      tooltip: 'You may be eligible for additional tuition discount as part of',
    },
    {
      value: 'roomAndBoard',
      label: 'Room & Board',
      fieldNo: '136',
      tooltip: '',
    },
    {
      value: 'miscellaneousFee',
      label: 'Miscellaneous Fee',
      fieldNo: '130',
      tooltip: '',
    },
  ];

  institutionalAid = [
    {
      value: 'Merit Scholarship',
      label: 'Merit Scholarship',
      name: 'meritBasedAid',
    },
    {
      value: 'Need Scholarship',
      label: 'Financial Aid Grant',
      name: 'needBasedAid',
    },
  ];

  collegeWiseProgram = [
    {
      value: 'increaseInLifeTimeEarnings',
      label: 'Increase In Life Time Earnings',
      tooltip:
        "Total increase in lifetime earnings (assuming 42 years of work life) if you take a course in the mentioned program in this college against earnings you'd have made had you not undergone any program.",
    },
    {
      value: 'lifetimeROI',
      label: 'Life Time ROI',
      tooltip:
        'Total capital returns on all expenses borne during 4-year of program duration in terms of earnings gain.',
    },
    {
      value: 'ageWhenROITurnsPositive',
      label: 'Age when ROI turns Positive',
      tooltip:
        'Median age of a typical student when they recover all costs borne during the course degree if you take a program in this category.',
    },
    {
      fieldno: 2,
      value: 'npvAfterNYears',
      // label: 'Net Present Value (after 40 years)',
      label: 'Estimated Annual Earnings after Graduation',
      tooltip:'Estimated Annual Earnings after Graduation.',
      // tooltip:'The net present value is how much a sum of money in the future is valued today. This metric includes costs, future earnings, and the length of time it would take to invest and earn a certain amount of money over a fixed horizon.',
    }
  ];

  collegeFederalAid = [
    { value: 'pellGrant', label: 'Pell Grant', name: 'pellGrant' },
    { value: 'fseog', label: 'FSEOG', name: 'fseog' },
    // {'value':'federalGrant','label':'Federal Grant'},
  ];
  ddlWithAwardletter = [
    { value: 'ocrData', label: 'Award Letter' },
    // { value: 'ipeds', label: 'IPEDS' },
    { value: 'top5', label: 'Top 5' },
    // { value: 'npc', label: 'NPC' },
  ];

  ddlWithOutAwardletter = [
    { value: 'npc', label: 'NPC' },
    { value: 'ipeds', label: 'IPEDS' },
  ];
  stateGrantList = [
    { value: 'stateGrant', label: 'State Grant', name: 'stateAid' },
  ];



}
